import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		device: 'pc',
		gnbMode: 'pc',
		heightSate: '',
		testMode: true,
		dataUrl: 'https://www.twosonsoft.com',
		gnb: {
			menuList: [
				{
					txt: '',
					subMenu: []
				}, {
					txt: '',
					subCategory: [
						{
							txt: '',
							link: '',
							subMenu: [
								{}
							]
						},
						{
							txt: '',
							link: '',
							subMenu: [
								{}
							]
						}
					]
				}, {
					txt: '',
					subMenu: []
				}
			]
		},
		basicInfo: {}
	},
	mutations: {
		currentDevice (state, device) {
			state.device = device
		},
		currentHeight (state, type) {
			state.heightSate = type
		},
		SET_GNB (state, gnb) {
			state.gnb = gnb
		}
	},
	getters: {
		getUrlPrefix: state => {
			return state.testMode ? state.dataUrl : ''
		},
		isHeightShort: state => {
			return state.heightSate === 'short'
		}
	},
	actions: {
		getGnb ({ commit, state }) {
			axios.get(state.dataUrl + '/gnbJsonData')
				.then(response => {
					commit('SET_GNB', response.data)
				})
				.catch(e => {
					console.log(e)
				})
		}
	}
})
